import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Routes } from '../../constants/RouteConstants'
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Skeleton from '../../components/ui/Skeleton';
import Button from '../../components/ui/Button';
import { USER_ROLE_TYPES } from '../../constants/Constants';
import toast from 'react-hot-toast';
import ProfileImage from '../../components/layouts/ProfileImage';

const HouseholdMembers = ({ profileData }: any) => {
    const hhMembers = useMakeRequest();
    const leaveHousue = useMakeRequest();

    const profile = profileData?.data || {};



    useEffect(() => {
        if (profile?.hh_member) {
            hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
        }
    }, [profile])

    const handleLeaveHouse = () => {
        toast.promise(
            leaveHousue.makeRequest({
                url: ApiConstants?.LeaveHousehold,
                payload: {
                    household_id: profile?.hh_member?.household?.id
                },
                type: 'POST'
            }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }

    useEffect(() => {
        if (leaveHousue?.status) {
            console.log("leaveHousue - - - - >", leaveHousue)
            hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
            profileData?.makeRequest({ url: ApiConstants?.Profile, type: 'GET' });
            // $('.btn-close-leave-house-modal').click()
            document.getElementById('btn-close-leave-house-modal')?.click();

            // Optional fail-safe: remove backdrop if stuck
            document.querySelector('.modal-backdrop')?.remove();
        }
    }, [leaveHousue?.status])

    const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;
    const isPremiumUser = profile?.is_free_plan || profile?.is_premium || profile?.is_household_premium;

    const handleManageHouseholdClick = (e: { preventDefault: () => void; }) => {
        if (isAdmin && !isPremiumUser) {
            e.preventDefault();
            toast.error('Please purchase a subscription to access these app features.');
            return;
        }
    };

    return (
        <>
            <div className='dash-household'>
                <div className='d-flex align-items-center mb-4'>
                    <h2 className='dash-household-title'>Members</h2>
                    <Link
                        to={Routes?.ManageHousehold}
                        className='household-edit ms-auto'
                        onClick={handleManageHouseholdClick}
                    >
                        {!isAdmin ? 'View' : 'Edit'}
                    </Link>
                </div>
                <ul className='household-list'>

                    {
                        hhMembers?.loading ?
                            Array.from({ length: 3 })?.map(() => (
                                <li >
                                    <Skeleton className='skeleton-loader mem-img' style={{ width: '40px', borderRadius: '50px' }} />
                                    <Skeleton className='skeleton-loader mem-name' style={{ width: '40%', height: '25px', borderRadius: '5px' }} />
                                </li>
                            )) :
                            hhMembers?.data?.data?.length > 0 ?
                                hhMembers?.data?.data?.map((memb: any, membIndex: any) => {
                                    return (
                                        <li key={membIndex}>

                                            <ProfileImage src={memb?.user?.profile_pic} size={60} />
                                            {/* {memb?.user?.profile_pic ?
                                                <img className='mem-img' src={memb?.user?.profile_pic} alt={memb?.user?.name} />
                                                :
                                                <div className="menu-icon-wrap">
                                                    <i className="menu-img icon-profile"></i>
                                                </div>
                                            } */}

                                            <div className='mem-name'>{memb?.user?.name}</div>
                                        </li>
                                    )
                                })
                                : ""
                    }

                </ul>

            </div>
            <div className="modal fade inner-modal com-modal" id="leaveHouseModal" tabIndex={-1} aria-labelledby="leaveHouseModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body pt-4 pb-0">
                            <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> leave this household?</p>
                        </div>
                        <div className='modal-footer border-0 mt-3 justify-content-center'>
                            <button type='button' className='com-btn com-btn-gray' id='btn-close-leave-house-modal' data-bs-dismiss="modal"  >Cancel</button>
                            <Button type='button' className='com-btn' data-bs-dismiss="modal" onClick={handleLeaveHouse} loading={leaveHousue.loading}>Confirm</Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HouseholdMembers